// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2-ZFr","head":"ProcedureTableInfo_head__128lL"};